// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --padding-start: 0;
  --padding-end: 0;
  --overflow: auto;
  --scrollbar-width: thin;
}

ion-avatar {
  width: 56px;
  height: 56px;
  margin: 0;
}

ion-searchbar {
  margin: 10px;
}

.transparent {
  background-color: transparent;
  cursor: pointer; /* Change the cursor to pointer */
}

ion-list ion-item {
  display: flex;
  align-items: center;
  cursor: pointer;
}
ion-list ion-item:hover {
  background-color: var(--mc-surface-f0);
  --background: var(--mc-surface-f0);
}
ion-list ion-item .contact-image-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #007bff;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  text-transform: uppercase;
  color: white;
  width: 56px;
  height: 56px;
  border-radius: 50%;
}

p {
  color: var(--mc-color-mid-grey);
  font-size: 12px;
  line-height: 20px;
}

ion-content::-webkit-scrollbar {
  width: 6px;
}

.ios .searchbar-wrap, .md .searchbar-wrap {
  margin: 0px 26px 0px 6px;
}

strong {
  color: var(--mc-color-black);
  font-size: 12px;
  font-weight: 500;
  line-height: 19px;
}

.sort-dropdown {
  padding-bottom: 0px;
  font-size: 12px;
  font-weight: 500;
}

.detail-icon {
  --inner-padding-end: 0px;
}

.item-selected {
  --background: var(--mc-surface-f0);
  background-color: var(--mc-surface-f0);
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/select-product/select-product.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,SAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AACA;EACI,6BAAA;EACA,eAAA,EAAA,iCAAA;AAEJ;;AAEI;EACI,aAAA;EACA,mBAAA;EAEA,eAAA;AAAR;AAEQ;EACI,sCAAA;EACA,kCAAA;AAAZ;AAGQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AADZ;;AAQA;EACI,+BAAA;EACA,eAAA;EACA,iBAAA;AALJ;;AAUI;EACI,UAAA;AAPR;;AAWA;EACI,wBAAA;AARJ;;AAWA;EACI,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AARJ;;AAWA;EACI,mBAAA;EACA,eAAA;EACA,gBAAA;AARJ;;AAWE;EACE,wBAAA;AARJ;;AAWI;EACI,kCAAA;EACA,sCAAA;AARR","sourcesContent":["ion-content {\r\n    --padding-start: 0;\r\n    --padding-end: 0;\r\n    --overflow: auto;\r\n    --scrollbar-width: thin;\r\n}\r\n\r\nion-avatar {\r\n    width: 56px;\r\n    height: 56px;\r\n    margin: 0;\r\n}\r\n\r\nion-searchbar {\r\n    margin: 10px;\r\n}\r\n.transparent {\r\n    background-color: transparent;\r\n    cursor: pointer; /* Change the cursor to pointer */\r\n  }\r\n\r\nion-list {\r\n    ion-item {\r\n        display: flex;\r\n        align-items: center;\r\n        // border-bottom: 1px solid #ccc;\r\n        cursor: pointer;\r\n\r\n        &:hover {\r\n            background-color: var(--mc-surface-f0);\r\n            --background: var(--mc-surface-f0);\r\n        }\r\n\r\n        .contact-image-wrap {\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            background-color: #007bff;\r\n            font-size: 20px;\r\n            font-weight: 400;\r\n            text-align: center;\r\n            text-transform: uppercase;\r\n            color: white;\r\n            width: 56px;\r\n            height: 56px;\r\n            border-radius: 50%;\r\n\r\n\r\n        }\r\n    }\r\n}\r\n\r\np {\r\n    color: var(--mc-color-mid-grey);\r\n    font-size: 12px;\r\n    line-height: 20px;\r\n}\r\n\r\nion-content {\r\n\r\n    &::-webkit-scrollbar {\r\n        width: 6px;\r\n    }\r\n}\r\n\r\n.ios .searchbar-wrap, .md .searchbar-wrap {\r\n    margin: 0px 26px 0px 6px\r\n}\r\n\r\nstrong {\r\n    color: var(--mc-color-black);\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    line-height: 19px;\r\n}\r\n\r\n.sort-dropdown {\r\n    padding-bottom: 0px;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n  }\r\n\r\n  .detail-icon {\r\n    --inner-padding-end: 0px;\r\n  }\r\n\r\n    .item-selected {\r\n        --background: var(--mc-surface-f0);\r\n        background-color: var(--mc-surface-f0);\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
